import { createContext, use } from "react";
import { defined } from "@entrilia/shared/utilities/typeHelper";
import type { Category } from "../../../../api/types/accessTypes";

export interface Props {
  hasEditPermissions: boolean;
  categories: Category[];
  onDeleteConsent: (consentName: string) => void;
}

export const UserConsentsSectionContext = createContext<Props | undefined>(undefined);

export const useUserConsentsSectionContext = () =>
  defined(use(UserConsentsSectionContext), "Attempt to use UserConsentsSectionContext without provider");
